<template>

    <div class="showTokenWrapper" v-if="value">

      <b-button block variant="outline-secondary" style="text-align: left; overflow: clip" @click="showToken = !showToken">
        <b-icon icon="arrow-bar-down" v-if="!showToken"></b-icon><b-icon icon="arrow-bar-up" v-else></b-icon>
        {{ value.cardcode }} | {{ value.kunde }} | {{ value.zipcode }} {{ value.ort }} {{ value.adresse }}
      </b-button>
      <b-alert show variant="light" v-if="showToken">

        <p>
          {{ token }}
        </p>
        <div class="row">
          <div class="col">
            <b-button variant="outline-info"
                      v-b-tooltip.hover
                      :title="$t('message.api_token_copy_it')"
                      size="sm"
                      @click="copyToClipboard">
              <b-icon icon="box-arrow-in-down-right"
                      class="cursor-pointer">
              </b-icon>
            </b-button>
          </div>
          <div class="col text-right">
            <!-- Token erneuern -->
            <b-button variant="outline-danger"
                      v-b-tooltip.hover
                      :title="$t('message.showToken_refresh_token')"
                      size="sm"
                      @click="refreshToken">
              <b-icon icon="arrow-repeat"></b-icon>
            </b-button>
          </div>
        </div>

      </b-alert>

    </div>

</template>

<script>

  import axios from 'axios'
  import bootbox from 'bootbox'

  export default {
    name: 'ShowToken',
    props: [
      /** der Kunde */
      'value'
    ],
    data: function () {
      return {
        showToken: false,
        token: null,
      }
    },
    watch: {
      value: {
        handler: function () {
          this.init()
        },
        deep: true
      }
    },
    methods: {
      copyToClipboard() {
        navigator.clipboard.writeText(this.value.token)
          .then(() => {
            // Feedback für erfolgreiche Kopieraktion hinzufügen
            this.$bvToast.toast(this.$t('message.api_token_copy'), {
              // title: 'BootstrapVue Toast',
              autoHideDelay: 5000,
            })
          })
          .catch(err => {
            console.error('Fehler beim Kopieren:', err)
          })
      },
      /**
       * Token erneuern
       */
      refreshToken() {

        const that = this
        const text = this.$t('message.showToken_refresh_token_confirm_text')
        bootbox.confirm(text, result => {
          if (result) {

            that.doRefreshToken()

          }
        })

      },
      doRefreshToken() {

        const url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/refreshToken'
        const that    = this
        var params  = {
          customer_id: this.value.id,
        }
        axios({
          method: 'GET',
          params: params,
          url: url,
        }).then(response => {

          that.token = response.data.token
          if (that.$store.getters.standorte) {

            for (var i = 0; i < that.$store.getters.standorte.length; i++) {
              if (that.value.id == that.$store.getters.standorte[i].id) {
                that.$store.getters.standorte[i].token = that.token
              }
            }

          } else if (that.$store.getters.customer) {
            that.$store.getters.customer.token = that.token
          }

        })

      },
      init: function () {

        if (this.value) this.token = this.value.token

      }
    },
    created () {

      this.init();

    },
  }

</script>
